import { render, staticRenderFns } from "./detalhes.vue?vue&type=template&id=ba50e1ac&"
import script from "./detalhes.vue?vue&type=script&lang=js&"
export * from "./detalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports